module.exports = __webpack_public_path__ + "img/simplified-residence-mini.02c77827.png";